
// import pdfIcon from "./../../assets/images/pdf.png";
// import ssoImg1 from "./../../assets/images/checklists-form-img.png";
// import { WebApiURL } from './../../Constants/Constants';
// import { useFileContext } from './../../Contexts/FileContext';
// import { FaFilePdf } from "react-icons/fa";
// import React, { useEffect, useMemo, useState } from 'react';



// function AwardedT() {
//   const [activeIndex, setActiveIndex] = useState(0);
//   const { setComponentName, setSection, documents, loading } = useFileContext();
//   useEffect(() => {
//     setComponentName("Awarded Tenders");
//   }, [setComponentName]);
//   // Extract unique sections dynamically
//   const sections = useMemo(() => {
//     const sectionSet = new Set();
//     documents?.forEach((doc) => {
//       const section = typeof doc?.section === 'string' ? doc.section.trim() : '';
//       if (section) sectionSet.add(section);
//     });
//     return Array.from(sectionSet);
//   }, [documents]);
//   const renderDocumentsBySection = (sectionName) => {
//     const docs = documents?.filter(doc =>
//       String(doc?.section || '').trim().toLowerCase() === String(sectionName || '').trim().toLowerCase()
//     );
//     const grouped = docs?.reduce((acc, doc) => {
//       const folder = doc?.folderName || doc?.section || "Uncategorized";
//       if (!acc[folder]) acc[folder] = [];
//       acc[folder].push(doc);
//       return acc;
//     }, {});
//     return (
//       <ul className="strip-ul">
//         {Object.entries(grouped).map(([folderName, folderDocs], idx) => (
//           <li key={idx}>
//             <div className="row g-4">
//               <div className="col">
//                 <div className="row g-4">
//                   <div className="col-md">
//                     <div className="font-16 font-400">
//                       <div className="container">
//                         <div className="row tender-header d-none d-md-flex">
//                           <div className="col-md-12 fw-semibold">File Path</div>
//                         </div>

//                         {folderDocs.map((doc, i) => (
//                           <div
//                             key={i}
//                             className={`row tender-row ${i % 2 === 0 ? "even" : "odd"}`}
//                           >
//                             <div className="col-12 col-md-12 text-truncate">
//                               {doc.filePath}
//                             </div>
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   </div>
//                   <div className="col-md-auto">
//                     <div className="font-16 font-400">
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </li>
//         ))}
//       </ul>

//     );
//   };
//   return (
//     <>
//       <div className="service-title text-green-38B652 font-700 mb-3">
//         Request for Quotation
//         <span className="text-orange-ef3e33 font-400"></span>
//       </div>
//       <div className="row g-3 g-sm-4 g-md-4">
//         <div className="col-12">
//           <div className="accordion blackTab" id="blackTab">
//             {sections?.map((sectionName, idx) => (
//               <div className="accordion-item" key={sectionName}>
//                 <h2 className="accordion-header">
//                   <button
//                     className={`accordion-button ${activeIndex !== idx ? "collapsed" : ""}`}
//                     type="button"
//                     data-bs-toggle="collapse"
//                     data-bs-target={`#section-${idx}`}
//                     aria-expanded={idx === 0 ? "true" : "false"}
//                     aria-controls={`section-${idx}`}
//                     onClick={() => setActiveIndex(idx)}
//                   >
//                     {sectionName}
//                   </button>
//                 </h2>
//                 <div
//                   id={`section-${idx}`}
//                   className={`accordion-collapse collapse ${activeIndex === idx ? "show" : ""}`}
//                   data-bs-parent="#blackTab"
//                 >
//                   <div className="accordion-body px-0">
//                     {loading ? (
//                       <div>Loading documents...</div>
//                     ) : (
//                       renderDocumentsBySection(sectionName)
//                     )}
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>


//       </div>
//     </>
//   );
// }

// export default AwardedT;


// import pdfIcon from "./../../assets/images/pdf.png";
// import ssoImg1 from "./../../assets/images/checklists-form-img.png";
// import { WebApiURL } from './../../Constants/Constants';
// import { useFileContext } from './../../Contexts/FileContext';
// import { FaFilePdf } from "react-icons/fa";
// import React, { useEffect, useMemo, useState } from 'react';
// import mammoth from "mammoth";

// function AwardedT() {
//   const [activeIndex, setActiveIndex] = useState(0);
//   const { setComponentName, setSection, documents, loading } = useFileContext();
//   const [docContents, setDocContents] = useState({}); // Store content per file

//   useEffect(() => {
//     setComponentName("Awarded Tenders");
//   }, [setComponentName]);

//   // Extract unique sections dynamically
//   const sections = useMemo(() => {
//     const sectionSet = new Set();
//     documents?.forEach((doc) => {
//       const section = typeof doc?.section === 'string' ? doc.section.trim() : '';
//       if (section) sectionSet.add(section);
//     });
//     return Array.from(sectionSet);
//   }, [documents]);

//   // Fetch and parse DOCX content for each file
//   const loadDocxContent = async (doc) => {
//     if (docContents[doc.filePath]) return; // Skip if already loaded
//     try {
//       // Ideally your API should give a URL to fetch instead of filePath
//       const response = await fetch(`${WebApiURL}/files?path=${encodeURIComponent(doc.filePath)}`);
//       if (!response.ok) throw new Error("Failed to fetch file");

//       const arrayBuffer = await response.arrayBuffer();
//       const { value } = await mammoth.convertToHtml({ arrayBuffer }); // ✅ Converts to basic HTML
//       setDocContents((prev) => ({ ...prev, [doc.filePath]: value || "<p>No content found</p>" }));
//     } catch (error) {
//       console.error("Error loading document:", error);
//       setDocContents((prev) => ({ ...prev, [doc.filePath]: "<p>Failed to load document</p>" }));
//     }
//   };

//   const renderDocumentsBySection = (sectionName) => {
//     const docs = documents?.filter(doc =>
//       String(doc?.section || '').trim().toLowerCase() === String(sectionName || '').trim().toLowerCase()
//     );
//     const grouped = docs?.reduce((acc, doc) => {
//       const folder = doc?.folderName || doc?.section || "Uncategorized";
//       if (!acc[folder]) acc[folder] = [];
//       acc[folder].push(doc);
//       return acc;
//     }, {});
//     return (
//       <ul className="strip-ul">
//         {Object.entries(grouped).map(([folderName, folderDocs], idx) => (
//           <li key={idx}>
//             <div className="row g-4">
//               <div className="col">
//                 <div className="row g-4">
//                   <div className="col-md">
//                     <div className="font-16 font-400">
//                       <div className="container">
//                         <div className="row tender-header d-none d-md-flex">
//                           <div className="col-md-12 fw-semibold">Tender Document</div>
//                         </div>

//                         {folderDocs.map((doc, i) => (
//                           <div
//                             key={i}
//                             className={`row tender-row ${i % 2 === 0 ? "even" : "odd"}`}
//                             onClick={() => loadDocxContent(doc)}
//                           >
//                             <div className="col-12 col-md-12">
//                               <strong>{doc.filePath}</strong>
//                               <div
//                                 className="docx-content mt-2"
//                                 style={{ whiteSpace: "normal" }}
//                                 dangerouslySetInnerHTML={{
//                                   __html: docContents[doc.filePath] || "<em>Click to load content...</em>"
//                                 }}
//                               />
//                             </div>
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   </div>
//                   <div className="col-md-auto">
//                     <div className="font-16 font-400"></div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </li>
//         ))}
//       </ul>
//     );
//   };

//   return (
//   <>
//     {loading ? (
//       <div className="text-center py-5">
//         <div className="spinner-border text-success mb-3" role="status" />
//         <div>Loading documents, please wait...</div>
//       </div>
//     ) : (
//       <>
//         <div className="service-title text-green-38B652 font-700 mb-3">
//           Request for Quotation
//         </div>

//         <div className="row g-3 g-sm-4 g-md-4">
//           <div className="col-12">
//             <div className="accordion blackTab" id="blackTab">
//               {sections?.map((sectionName, idx) => (
//                 <div className="accordion-item" key={sectionName}>
//                   <h2 className="accordion-header">
//                     <button
//                       className={`accordion-button ${
//                         activeIndex !== idx ? "collapsed" : ""
//                       }`}
//                       type="button"
//                       data-bs-toggle="collapse"
//                       data-bs-target={`#section-${idx}`}
//                       aria-expanded={idx === 0 ? "true" : "false"}
//                       aria-controls={`section-${idx}`}
//                       onClick={() => setActiveIndex(idx)}
//                     >
//                       {sectionName}
//                     </button>
//                   </h2>
//                   <div
//                     id={`section-${idx}`}
//                     className={`accordion-collapse collapse ${
//                       activeIndex === idx ? "show" : ""
//                     }`}
//                     data-bs-parent="#blackTab"
//                   >
//                     <div className="accordion-body px-0">
//                       {renderDocumentsBySection(sectionName)}
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </>
//     )}
//   </>
// );

// }

// export default AwardedT;

// import pdfIcon from "./../../assets/images/pdf.png";
// import ssoImg1 from "./../../assets/images/checklists-form-img.png";
// import { WebApiURL } from "./../../Constants/Constants";
// import { useFileContext } from "./../../Contexts/FileContext";
// import { FaFilePdf } from "react-icons/fa";
// import React, { useEffect, useMemo, useState } from "react";
// import mammoth from "mammoth";

// function AwardedT() {
//   const [activeIndex, setActiveIndex] = useState(0);
//   const { setComponentName, documents, loading } = useFileContext();
//   const [docContents, setDocContents] = useState({});

//   useEffect(() => {
//     setComponentName("Awarded Tenders");
//   }, [setComponentName]);

//   // Debug logs to confirm data is coming in
//   console.log("documents:", documents);
//   console.log("loading:", loading);

//   // Extract unique sections dynamically
//   const sections = useMemo(() => {
//     const sectionSet = new Set();
//     documents?.forEach((doc) => {
//       const section = typeof doc?.section === "string" ? doc.section.trim() : "";
//       if (section) sectionSet.add(section);
//     });
//     return Array.from(sectionSet);
//   }, [documents]);

//   // Fetch and parse DOCX content for each file
//   const loadDocxContent = async (doc) => {
//     if (docContents[doc.filePath]) return; // Skip if already loaded
//     try {
//       const response = await fetch(
//         `${WebApiURL}/files?path=${encodeURIComponent(doc.filePath)}`
//       );
//       if (!response.ok) throw new Error("Failed to fetch file");

//       const arrayBuffer = await response.arrayBuffer();
//       const { value } = await mammoth.convertToHtml({ arrayBuffer });
//       setDocContents((prev) => ({
//         ...prev,
//         [doc.filePath]: value || "<p>No content found</p>",
//       }));
//     } catch (error) {
//       console.error("Error loading document:", error);
//       setDocContents((prev) => ({
//         ...prev,
//         [doc.filePath]: "<p>Failed to load document</p>",
//       }));
//     }
//   };

//   const renderDocumentsBySection = (sectionName) => {
//     const docs = documents?.filter(
//       (doc) =>
//         String(doc?.section || "").trim().toLowerCase() ===
//         String(sectionName || "").trim().toLowerCase()
//     );
//     const grouped = docs?.reduce((acc, doc) => {
//       const folder = doc?.folderName || doc?.section || "Uncategorized";
//       if (!acc[folder]) acc[folder] = [];
//       acc[folder].push(doc);
//       return acc;
//     }, {});
//     return (
//       <ul className="strip-ul">
//         {Object.entries(grouped).map(([folderName, folderDocs], idx) => (
//           <li key={idx}>
//             <div className="row g-4">
//               <div className="col">
//                 <div className="row g-4">
//                   <div className="col-md">
//                     <div className="font-16 font-400">
//                       <div className="container">
//                         <div className="row tender-header d-none d-md-flex">
//                           <div className="col-md-12 fw-semibold">
//                             Tender Document
//                           </div>
//                         </div>

//                         {folderDocs.map((doc, i) => (
//                           <div
//                             key={i}
//                             className={`row tender-row ${
//                               i % 2 === 0 ? "even" : "odd"
//                             }`}
//                             onClick={() => loadDocxContent(doc)}
//                           >
//                             <div className="col-12 col-md-12">
//                               <strong>{doc.filePath}</strong>
//                               <div
//                                 className="docx-content mt-2"
//                                 style={{ whiteSpace: "normal" }}
//                                 dangerouslySetInnerHTML={{
//                                   __html:
//                                     docContents[doc.filePath] ||
//                                     "<em>Click to load content...</em>",
//                                 }}
//                               />
//                             </div>
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   </div>
//                   <div className="col-md-auto">
//                     <div className="font-16 font-400"></div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </li>
//         ))}
//       </ul>
//     );
//   };

//   return (
//     <div className="container py-4">
//       {loading ? (
//         // ✅ Show this while documents are being fetched
//         <div className="text-center py-5">
//           <div className="spinner-border text-success mb-3" role="status" />
//           <div>Loading documents, please wait...</div>
//         </div>
//       ) : sections.length === 0 ? (
//         // ✅ Show this when no documents exist
//         <div className="text-center py-5">
//           <div>No documents found.</div>
//         </div>
//       ) : (
//         // ✅ Show this when data has finished loading
//         <>
//           <div className="service-title text-green-38B652 font-700 mb-3">
//             Request for Quotation
//           </div>

//           <div className="accordion blackTab" id="blackTab">
//             {sections.map((sectionName, idx) => (
//               <div className="accordion-item" key={sectionName}>
//                 <h2 className="accordion-header">
//                   <button
//                     className={`accordion-button ${
//                       activeIndex !== idx ? "collapsed" : ""
//                     }`}
//                     type="button"
//                     data-bs-toggle="collapse"
//                     data-bs-target={`#section-${idx}`}
//                     aria-expanded={activeIndex === idx}
//                     aria-controls={`section-${idx}`}
//                     onClick={() => setActiveIndex(idx)}
//                   >
//                     {sectionName}
//                   </button>
//                 </h2>

//                 <div
//                   id={`section-${idx}`}
//                   className={`accordion-collapse collapse ${
//                     activeIndex === idx ? "show" : ""
//                   }`}
//                   data-bs-parent="#blackTab"
//                 >
//                   <div className="accordion-body px-0">
//                     {renderDocumentsBySection(sectionName)}
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </>
//       )}
//     </div>
//   );
// }

// export default AwardedT;



// import pdfIcon from "./../../assets/images/pdf.png";
// import ssoImg1 from "./../../assets/images/checklists-form-img.png";
// import { WebApiURL } from "./../../Constants/Constants";
// import { useFileContext } from "./../../Contexts/FileContext";
// import { FaFilePdf } from "react-icons/fa";
// import React, { useEffect, useMemo, useState } from "react";
// import mammoth from "mammoth";

// function AwardedT() {
//   const [activeIndex, setActiveIndex] = useState(0);
//   const { setComponentName, documents, loading } = useFileContext();
//   const [docContents, setDocContents] = useState({});

//   useEffect(() => {
//     setComponentName("Awarded Tenders");
//   }, [setComponentName]);

//   const sections = useMemo(() => {
//     const sectionSet = new Set();
//     documents?.forEach((doc) => {
//       const section = typeof doc?.section === "string" ? doc.section.trim() : "";
//       if (section) sectionSet.add(section);
//     });
//     return Array.from(sectionSet);
//   }, [documents]);

//   const getFileUrl = (filePath) => {
//     return `${WebApiURL}/files?path=${encodeURIComponent(filePath)}`;
//   };

//   const loadFileContent = async (doc) => {
//     if (docContents[doc.filePath]) return;

//     const url = getFileUrl(doc.filePath);
//     try {
//       const response = await fetch(url);
//       if (!response.ok) throw new Error("Failed to fetch file");

//       const fileExtension = doc.filePath.split(".").pop().toLowerCase();

//       if (fileExtension === "docx") {
//         const arrayBuffer = await response.arrayBuffer();
//         const { value } = await mammoth.convertToHtml({ arrayBuffer });
//         setDocContents((prev) => ({
//           ...prev,
//           [doc.filePath]: value || "<p>No content found</p>",
//         }));
//       } else if (fileExtension === "txt") {
//         const html = await response.text();
//         setDocContents((prev) => ({
//           ...prev,
//           [doc.filePath]: html,
//         }));
//       } else {
//         setDocContents((prev) => ({
//           ...prev,
//           [doc.fileId]: "<p>Unsupported file type</p>",
//         }));
//       }
//     } catch (error) {
//       console.error("Error loading document:", error);
//       setDocContents((prev) => ({
//         ...prev,
//         [doc.fileId]: "<p>Failed to load document</p>",
//       }));
//     }
//   };

//   const renderDocumentsBySection = (sectionName) => {
//     const docs = documents?.filter(
//       (doc) =>
//         String(doc?.section || "").trim().toLowerCase() ===
//         String(sectionName || "").trim().toLowerCase()
//     );
//     const grouped = docs?.reduce((acc, doc) => {
//       const folder = doc?.folderName || doc?.section || "Uncategorized";
//       if (!acc[folder]) acc[folder] = [];
//       acc[folder].push(doc);
//       return acc;
//     }, {});
//     return (
//       <ul className="strip-ul">
//         {Object.entries(grouped).map(([folderName, folderDocs], idx) => (
//           <li key={idx}>
//             <div className="row g-4">
//               <div className="col">
//                 <div className="row g-4">
//                   <div className="col-md">
//                     <div className="font-16 font-400">
//                       <div className="container">
//                         <div className="row tender-header d-none d-md-flex">
//                           <div className="col-md-12 fw-semibold">
//                             Tender Document
//                           </div>
//                         </div>

//                         {folderDocs.map((doc, i) => (
//                           <div
//                             key={i}
//                             className={`row tender-row ${i % 2 === 0 ? "even" : "odd"}`}
//                             onClick={() => loadFileContent(doc)}
//                           >
//                             <div className="col-12 col-md-12">
//                               <strong>{doc.fileId}</strong>
//                               <div
//                                 className="docx-content mt-2"
//                                 style={{ whiteSpace: "normal" }}
//                                 dangerouslySetInnerHTML={{
//                                   __html:
//                                     docContents[doc.fileId] ||
//                                     "<em>Click to load content...</em>",
//                                 }}
//                               />
//                             </div>
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   </div>
//                   <div className="col-md-auto">
//                     <div className="font-16 font-400"></div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </li>
//         ))}
//       </ul>
//     );
//   };

//   return (
//     <div className="container py-4">
//       {loading ? (
//         <div className="text-center py-5">
//           <div className="spinner-border text-success mb-3" role="status" />
//           <div>Loading documents, please wait...</div>
//         </div>
//       ) : sections.length === 0 ? (
//         <div className="text-center py-5">
//           <div>No documents found.</div>
//         </div>
//       ) : (
//         <>
//           <div className="service-title text-green-38B652 font-700 mb-3">
//             Request for Quotation
//           </div>

//           <div className="accordion blackTab" id="blackTab">
//             {sections.map((sectionName, idx) => (
//               <div className="accordion-item" key={sectionName}>
//                 <h2 className="accordion-header">
//                   <button
//                     className={`accordion-button ${
//                       activeIndex !== idx ? "collapsed" : ""
//                     }`}
//                     type="button"
//                     data-bs-toggle="collapse"
//                     data-bs-target={`#section-${idx}`}
//                     aria-expanded={activeIndex === idx}
//                     aria-controls={`section-${idx}`}
//                     onClick={() => setActiveIndex(idx)}
//                   >
//                     {sectionName}
//                   </button>
//                 </h2>

//                 <div
//                   id={`section-${idx}`}
//                   className={`accordion-collapse collapse ${
//                     activeIndex === idx ? "show" : ""
//                   }`}
//                   data-bs-parent="#blackTab"
//                 >
//                   <div className="accordion-body px-0">
//                     {renderDocumentsBySection(sectionName)}
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </>
//       )}
//     </div>
//   );
// }

// export default AwardedT;

import pdfIcon from "./../../assets/images/pdf.png";
import ssoImg1 from "./../../assets/images/checklists-form-img.png";
import { WebApiURL } from "./../../Constants/Constants";
import { useFileContext } from "./../../Contexts/FileContext";
import { FaFilePdf } from "react-icons/fa";
import React, { useEffect, useMemo, useState } from "react";
import mammoth from "mammoth";

function AwardedT() {
  const [activeIndex, setActiveIndex] = useState(0);
  const { setComponentName, documents, loading } = useFileContext();
  const [docContents, setDocContents] = useState({});

  useEffect(() => {
    setComponentName("Awarded Tenders");
  }, [setComponentName]);

  const sections = useMemo(() => {
    const sectionSet = new Set();
    documents?.forEach((doc) => {
      const section = typeof doc?.section === "string" ? doc.section.trim() : "";
      if (section) sectionSet.add(section);
    });
    return Array.from(sectionSet);
  }, [documents]);

  const getFileUrl = (fileId) => {
    return `${WebApiURL}File/view/${encodeURIComponent(fileId)}`;
  };

  // Fetch all file contents when documents are loaded
  useEffect(() => {
    if (!documents || documents.length === 0) return;

    documents.forEach((doc) => {
      if (!docContents[doc.fileId]) {
        loadFileContent(doc);
      }
    });
    // eslint-disable-next-line
  }, [documents]);

  const loadFileContent = async (doc) => {
    if (docContents[doc.fileId]) return;

    const url = getFileUrl(doc.fileId);
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error("Failed to fetch file");

      const fileExtension = doc.filePath.split(".").pop().toLowerCase();

      if (fileExtension === "docx") {
        const arrayBuffer = await response.arrayBuffer();
        const { value } = await mammoth.convertToHtml({ arrayBuffer });
        setDocContents((prev) => ({
          ...prev,
          [doc.fileId]: value || "<p>No content found</p>",
        }));
      } else if (fileExtension === "txt" || fileExtension === "html") {
        const html = await response.text();
        setDocContents((prev) => ({
          ...prev,
          [doc.fileId]: html,
        }));
      } else {
        setDocContents((prev) => ({
          ...prev,
          [doc.fileId]: "<p>Unsupported file type</p>",
        }));
      }
    } catch (error) {
      console.error("Error loading document:", error);
      setDocContents((prev) => ({
        ...prev,
        [doc.fileId]: "<p>Failed to load document</p>",
      }));
    }
  };

  const renderDocumentsBySection = (sectionName) => {
    const docs = documents?.filter(
      (doc) =>
        String(doc?.section || "").trim().toLowerCase() ===
        String(sectionName || "").trim().toLowerCase()
    );
    const grouped = docs?.reduce((acc, doc) => {
      const folder = doc?.folderName || doc?.section || "Uncategorized";
      if (!acc[folder]) acc[folder] = [];
      acc[folder].push(doc);
      return acc;
    }, {});
    return (
      <ul className="strip-ul">
        {Object.entries(grouped).map(([folderName, folderDocs], idx) => (
          <li key={idx}>
            <div className="row g-4">
              <div className="col">
                <div className="row g-4">
                  <div className="col-md">
                    <div className="font-16 font-400">
                      <div className="container">
                        <div className="row tender-header d-none d-md-flex">
                          <div className="col-md-12 fw-semibold">
                            Tender Document
                          </div>
                        </div>

                        {folderDocs.map((doc, i) => (
                          <div
                            key={i}
                            className={`row tender-row ${i % 2 === 0 ? "even" : "odd"}`}
                          >
                            <div className="col-12 col-md-12">
                              {/* <strong>{doc.filePath}</strong> */}
                              <div
                                className="docx-content mt-2"
                                style={{ whiteSpace: "normal" }}
                                dangerouslySetInnerHTML={{
                                  __html:
                                    docContents[doc.fileId] ||
                                    "<em>Loading content...</em>",
                                }}
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-auto">
                    <div className="font-16 font-400"></div>
                  </div>
                </div>
              </div>
            </div>
          </li>
        ))}
      </ul>
    );
  };

  return (
    <div className="container py-4">
      {loading ? (
        <div className="text-center py-5">
          <div className="spinner-border text-success mb-3" role="status" />
          <div>Loading documents, please wait...</div>
        </div>
      ) : sections.length === 0 ? (
        <div className="text-center py-5">
          <div>No documents found.</div>
        </div>
      ) : (
        <>
          <div className="service-title text-green-38B652 font-700 mb-3">
            Request for Quotation
          </div>

          <div className="accordion blackTab" id="blackTab">
            {sections.map((sectionName, idx) => (
              <div className="accordion-item" key={sectionName}>
                <h2 className="accordion-header">
                  <button
                    className={`accordion-button ${
                      activeIndex !== idx ? "collapsed" : ""
                    }`}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#section-${idx}`}
                    aria-expanded={activeIndex === idx}
                    aria-controls={`section-${idx}`}
                    onClick={() => setActiveIndex(idx)}
                  >
                    {sectionName}
                  </button>
                </h2>

                <div
                  id={`section-${idx}`}
                  className={`accordion-collapse collapse ${
                    activeIndex === idx ? "show" : ""
                  }`}
                  data-bs-parent="#blackTab"
                >
                  <div className="accordion-body px-0">
                    {renderDocumentsBySection(sectionName)}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

export default AwardedT;
